<script lang="ts" setup>
import { computed } from 'vue';
import { useTenantStore } from '@features/tenant/store/tenant';
import { chromeIdentity } from '@features/tenant/launcherChrome';

interface Props {
  showName?: boolean;
  markClass?: string;
  nameClass?: string;
}

const props = withDefaults(defineProps<Props>(), {
  showName: undefined,
  markClass: 'h-8 w-8',
  nameClass: 'text-lg font-bold text-[hsl(var(--text-primary))]',
});

const tenantStore = useTenantStore();

const identity = computed(() =>
  chromeIdentity(tenantStore.logoUrl, tenantStore.brandName),
);

const resolvedShowName = computed(
  () => props.showName ?? tenantStore.showBrandName,
);
</script>

<template>
  <span class="flex items-center gap-1.5" data-testid="brand-mark">
    <img
      v-if="identity.logoUrl"
      :src="identity.logoUrl"
      alt=""
      class="w-auto object-contain"
      :class="markClass"
    />
    <span
      v-else-if="identity.monogram"
      class="flex shrink-0 items-center justify-center rounded-lg bg-primary font-bold text-primary-foreground"
      :class="markClass"
      >{{ identity.monogram }}</span
    >
    <span v-if="resolvedShowName && identity.name" :class="nameClass">{{
      identity.name
    }}</span>
  </span>
</template>
